import { render, staticRenderFns } from "./DegreeForm.vue?vue&type=template&id=573ebc1e"
import script from "./DegreeForm.vue?vue&type=script&lang=js"
export * from "./DegreeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports